export default __webpack_public_path__ + "static/media/668.cea2bdd5.gif";